<template>
  <div>
    <Modal name="add-comment">
      <div style="padding: 15px;">
        <div class="row">
          <div class="col s8">
            <strong>{{ $t('logbook.addItem') }}</strong>
          </div>
          <div class="col s3">
            {{ today }}
          </div>
          <div class="col s1">
            <a @click="closeModal" style="cursor: pointer;">
              <i class="material-icons">
                close
              </i>
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col s12">
            <label>
              <input type="text" v-model="newItem" :placeholder="$t('logbook.placeholder')"
                     :style="'border-left: 4px solid ' + colors[0]" />
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col s12">
            <button
              type="button"
              class="right waves-effect waves-light btn buttonbg"
              @click="addItem"
            >
              {{ $t('logbook.add') }}
            </button>
          </div>
        </div>
      </div>
    </Modal>
    <div class="row"></div>
    <div class="row">
      <div class="col s9">
        <div class="row">
          <div class="col s12">
            <div class="z-depth-1 white" style="padding: 15px;">
              <span class="title">
                {{ $t('logbook.logbook') }}
              </span>
              <span class="">
                <button
                  type="button"
                  class="waves-effect waves-light btn buttonbg"
                  @click="getApiData"
                >
                  <i class="material-icons">
                    refresh
                  </i>
                </button>
                <button
                  type="button"
                  class="right waves-effect waves-light btn buttonbg"
                  @click="openModal"
                >
                  {{ $t('logbook.addItem') }}
                </button>
              </span>
              <table class="logs">
                <thead>
                  <tr>
                    <th class="date">{{ $t('logbook.date') }}</th>
                    <th>{{ $t('views.dashboard.list.railobjectname') }}</th>
                    <th>{{ $t('logbook.message') }}</th>
                    <th class="user">{{ $t('logbook.user') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="this.logs.length === 0">
                    <td colspan="3">
                      {{ $t('logbook.noneSelected') }}
                    </td>
                  </tr>
                  <tr v-for="(log, index) of logs" :key="index">
                    <td class="log">
                     {{ formatDate(log.dateTime) }}
                    </td>
                    <td class="log" :style="'border-right: 4px solid ' + colors[log.type - 1]">
                      {{ log.railObjectName }}
                    </td>
                    <td class="log">
                      <span class="measurement" v-if="log.measurementId">
                        {{ $t('logbook.measurement') }} {{ log.measurementDateTime }}<br />
                      </span>
                      {{ log.message }}
                    </td>
                    <td class="log">{{ log.user }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col s3">
        <div class="row">
          <div class="col s12">
            <div class="z-depth-1 white" style="padding: 15px;">
              <table class="types">
                <thead>
                  <tr>
                    <th colspan="2">Filter {{ $t('logbook.types') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(logType, index) of this.logTypes" :key="index"
                      :style="'border-left: 4px solid ' + colors[index]">
                    <td class="typeName">
                      <label class="checkbox-small">
                        <input type="checkbox" name="directionReverse" :id="typeIds[index]" :value="index+1"
                               v-model="selectedTypes" style="opacity: 0 !important;" />
                        <span class="checkbox-small body1"></span>
                      </label>
                      <label :for="typeIds[index]">
                        {{ logType }}
                      </label>
                    </td>
                    <td class="typeCount">
                      {{ typeCounts[index]}}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div style="margin-top: 15px">
                <button
                  type="button"
                  class="waves-effect waves-light btn buttonbg"
                  @click="excelExport"
                >
                  {{ $t('logbook.downloadExcel') }}
                  <svg
                    xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                    width="16" height="16"
                    viewBox="0 0 26 26"
                    style=" fill:#fff;"
                  >
                    <g id="surface1">
                      <!-- excel icon -->
                      <path
                        d="M 15 0 L 0 2.875 L 0 23.125 L 15 26 Z M 16 3 L 16 5.96875 L 19.03125 5.96875 L 19.03125 8
                        L 16 8 L 16 10 L 19 10 L 19 12 L 16 12 L 16 14 L 19 14 L 19 16 L 16 16 L 16 18 L 19 18 L 19
                        20 L 16 20 L 16 23 L 25.15625 23 C 25.617188 23 26 22.605469 26 22.125 L 26 3.875 C 26 3.394531
                        25.617188 3 25.15625 3 Z M 20 6 L 24 6 L 24 8 L 20 8 Z M 3.09375 7.9375 L 5.84375 7.9375 L
                        7.3125 11 C 7.425781 11.238281 7.535156 11.515625 7.625 11.84375 C 7.683594 11.644531 7.8125
                        11.359375 7.96875 10.96875 L 9.5625 7.9375 L 12.09375 7.9375 L 9.0625 12.96875 L 12.1875
                        18.09375 L 9.5 18.09375 L 7.75 14.78125 C 7.683594 14.660156 7.601563 14.421875 7.53125
                        14.09375 L 7.5 14.09375 C 7.46875 14.25 7.402344 14.496094 7.28125 14.8125 L 5.53125 18.09375
                        L 2.8125 18.09375 L 6.03125 13.03125 Z M 20 10 L 24 10 L 24 12 L 20 12 Z M 20 14 L 24 14 L 24
                        16 L 20 16 Z M 20 18 L 24 18 L 24 20 L 20 20 Z ">
                      </path>
                    </g>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AxleShuntApi from '@/services/api/axleshunt/AxleShuntApi'
import AuthenticationService from '@/services/AuthenticationService'
import RailObjectService from '@/services/RailObjectService'
import xlsx from 'xlsx'
import moment from 'moment'

export default {
  name: 'logs',
  data () {
    return {
      colors: ['#3cb44b', '#ffe119', '#e6194b', '#4363d8', '#f58231', '#42d4f4', '#f032e6'],
      logTypes: ['User Comment', 'Warning', 'Alarm', 'Reset Comment', 'Maintenance', 'Failure Log Import', 'Maintenance Log Import'],
      typeIds: ['userComment', 'warning', 'alarm', 'resetComment', 'maintenance', 'failureLogImport', 'maintenanceLogImport'],
      typeCounts: [0, 0, 0, 0, 0, 0, 0],
      selectedTypes: [1, 2, 3, 4, 5],
      apiData: [],
      railobjects: [],
      newItem: ''
    }
  },
  created: function () {
    this.getRailObjects()
    this.getApiData()
  },
  computed: {
    logs: function () {
      let result = []
      const found = this.railobjects.find(element => element.RailObjectId === this.$attrs['railObjectId'])
      this.apiData.forEach(d => {
        if (this.selectedTypes.indexOf(d.commentTypeId) !== -1) {
          result.push({
            dateTime: d.commentDateTime,
            type: d.commentTypeId,
            message: d.comment,
            user: d.userName,
            measurementId: 0,
            railObjectName: found.Name // de aanname dat we het logbook per asset laten zien, en niet voor de hele klant.
            // measurementDateTime: moment(d.measurementDateTime).format('DD-MM-YYYY HH:mm:ss')
          })
        }
      })
      result = result.sort((a, b) => b.dateTime - a.dateTime)
      return result
    },
    today: function () {
      return moment().format('DD-MM-YYYY, HH:mm')
    }
  },
  methods: {
    openModal () {
      this.$modal.show('add-comment')
    },
    closeModal () {
      this.$modal.hide('add-comment')
    },
    async getRailObjects () {
      let auth = RailObjectService.getRailObjects().filter((obj) => {
        return obj.PossObjectCodeId === 5
      })
      this.railobjects = auth
    },
    async addItem () {
      const user = await AuthenticationService.getUser()
      const dto = {
        Code: 1,
        RailObjectId: this.$attrs['railObjectId'],
        PossObjectCodeId: 5,
        Comment: this.newItem,
        CommentDateTime: moment().toISOString(true),
        MeasurementId: null,
        Isvalid: true,
        userId: user.UserId,
        userName: user.UserName
      }
      this.closeModal()
      await AxleShuntApi.addLogBook(dto)
      this.getApiData()
    },
    formatDate: (dateTime) => {
      const s = dateTime + ''
      const year = s.substring(0, 4)
      const month = s.substring(5, 7)
      const day = s.substring(8, 10)
      const hour = s.substring(11, 13)
      const minute = s.substring(14, 16)
      const second = s.substring(17, 19)
      return `${day}-${month}-${year}, ${hour}:${minute}:${second}`
    },
    getApiData () {
      if (!isNaN(this.$attrs['railObjectId'])) {
        this.filter =
        '?$filter=railobjectid eq ' +
        this.$attrs['railObjectId'] +
        ' &$orderby=CommentDateTime desc'
        AxleShuntApi.getLogBook(this.filter).then(result => {
          let counts = [0, 0, 0, 0, 0, 0, 0]
          this.apiData = result
          result.forEach(x => {
            counts[x.commentTypeId - 1] = counts[x.commentTypeId - 1] + 1
          })
          this.typeCounts = counts
        })
      }
    },
    excelExport () {
      const logsSheet = xlsx.utils.json_to_sheet(this.apiData)
      const workBook = xlsx.utils.book_new()

      xlsx.utils.book_append_sheet(workBook, logsSheet, 'logbook')

      xlsx.writeFile(workBook, `logbook_${this.$attrs['railObjectId'].ComplexName}.xlsx`)
    }
  },
  watch: {
    '$attrs.railObjectId' (val) {
      if (val) {
        this.getApiData()
      }
    }
  }
}
</script>

<style scoped>
  .types td {
    padding: 2px 5px;
  }

  .logs td.log {
    padding: 2px 5px;
    vertical-align: top;
  }

  .logs .date {
    width: 15%;
  }

  .logs .user {
    width: 15%;
  }

  .typeName label {
    font-size: 15px;
    color: black !important;
  }

  .types .typeCount {
    color: darkgray;
  }

  .buttonbg {
    background: #56CCF2;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);
    border-radius: 2px;
  }

  .measurement {
    color: #37474f;
    font-style: italic;
    font-weight: 500;
  }

  .title {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px !important;
    color: rgba(0, 0, 0, 0.87);
  }
</style>



// WEBPACK FOOTER //
// src/pages/axleshunt/Logbook/Index.vue